import { render } from "./SendDocuments.vue?vue&type=template&id=5ec60924&scoped=true"
import script from "./SendDocuments.vue?vue&type=script&lang=js"
export * from "./SendDocuments.vue?vue&type=script&lang=js"

import "./SendDocuments.vue?vue&type=style&index=0&id=5ec60924&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec60924"]])

export default __exports__